import React, { useEffect, useState } from "react";
import "./StakeV3.scss";
import { HiOutlineArrowSmRight, HiInformationCircle } from "react-icons/hi";
import Modal from "components/Modal/Modal";
import { Link } from "react-router-dom";
import PalmToken from "img/PalmToken.svg";

export const STAKE_ACTION = "STAKE_ACTION";
export const UNSTAKE_ACTION = "UNSTAKE_ACTION";
export const PALM_TOKEN = "PALM_TOKEN";
export const PLP_TOKEN = "PLP_TOKEN";

const fractions = [
  {
    value: 0.1,
    label: "10%",
  },
  {
    value: 0.25,
    label: "25%",
  },
  {
    value: 0.5,
    label: "50%",
  },
  {
    value: 0.75,
    label: "75%",
  },
  {
    value: 1,
    label: "100%",
  },
];

const StakeModal = ({ open, setOpen, stakeModalData }) => {
  const { action, token } = stakeModalData;
  const tokenName = token === PLP_TOKEN ? "PLP" : "PALM";
  const actionName = action === UNSTAKE_ACTION ? "Unstake" : "Stake";
  const stakeLink = "/buy";
  const balanceLabel = action === STAKE_ACTION ? "Balance" : "Palm Staked Balance";
  const infoText =
    action === STAKE_ACTION
      ? `To stake PLP tokens, you need to buy them on the Buy page. Once you buy PLP, they will be automatically added into the staking pool and earn 50% of the trading fees generated by the Palmswap Exchange. You can sell the PLP tokens at any time, and your tokens will automatically become unstaked.`
      : `To unstake PLP tokens, you need to sell them on the Buy page. Once you sell PLP, they will be automatically unstaked. The rewards you have received so far can be claimed even after you have sold PLP, but you will not receive any new rewards.`;

  // const { account, library } = useWeb3React();
  // const [palmBalance, setPalmBalance] = useState();
  // const [palmPrice, setPalmPrice] = useState();
  const [amount, setAmount] = useState("");
  const [amountInUsd] = useState();
  const [fraction, setFraction] = useState();
  const [annualRoi] = useState(0);

  useEffect(() => {
    if (fraction) {
    }
  }, [fraction]);

  const handleStake = async () => {};

  const handleUnstake = async () => {};

  const handleConfirm = async () => {
    if (action === STAKE_ACTION) {
      await handleStake();
    } else handleUnstake();
  };

  return (
    <Modal
      className="Connect-wallet-modal"
      isVisible={open}
      setIsVisible={setOpen}
      label={`${actionName} ${tokenName}`}
    >
      {token === PALM_TOKEN ? (
        <div className="Earn-modal">
          <div className="Stake-modal-top-section">
            <div className="inactive-text">Amount</div>
            <div className="input-wrapper">
              <input
                type={"number"}
                className="Earn-input"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
              <div className="input-end-content">
                <div className="inactive-text">~${amountInUsd}</div>
              </div>
            </div>

            <div className="inactive-text">{balanceLabel} - PALM</div>
            <div className="fraction-selector-wrapper">
              {fractions.map((fraction, i) => (
                <div className="fraction-selector-item" key={i} onClick={() => setFraction(fraction.value)}>
                  {fraction.label}
                </div>
              ))}
            </div>
          </div>
          <div className="Stake-modal-bottom-section">
            {action === STAKE_ACTION && (
              <>
                <div className="label-value">
                  <div className="inactive-text">Estimated annual ROI</div>
                  <div className="inactive-text">{annualRoi} USDT</div>
                </div>
                <a
                  className="Modal-info-card"
                  rel="noopener noreferrer"
                  href="https://pancakeswap.finance/swap?outputCurrency=0x29745314B4D294B7C77cDB411B8AAa95923aae38"
                >
                  <img src={PalmToken} alt="token" className="Token-icon" />
                  <div className="info-block popup-infoblock">
                    <div className="white-text">Get tokens on Pancakeswap</div>
                    <div className="inactive-text">PALM</div>
                  </div>
                  <HiOutlineArrowSmRight className="right-arrow" />
                </a>
              </>
            )}
            <button onClick={handleConfirm} className="button primary-action w-100">
              {actionName}
            </button>
          </div>
        </div>
      ) : (
        <div className="Earn-modal">
          <div className="Stake-modal-top-section">
            <div className="Stake-modal-info">
              <div>
                <HiInformationCircle className="inactive-text" />
              </div>
              <div className="inactive-text">{infoText}</div>
            </div>
          </div>
          <div className="Stake-modal-bottom-section">
            <Link className="button primary-action w-100" to={stakeLink}>
              Visit 'Buy PLP'
            </Link>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default StakeModal;
